/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback } from "react";

import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
  Typography,
} from "@material-ui/core";

import componentStyles from "assets/theme/views/index"; // "assets/theme/views/admin/react-bs-table";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import InputText from "components/_refactor/text/input";
import Api from "lib/api/httpRequestHelper";

const useStyles = makeStyles(componentStyles);

export default function DialogRetirada({
  open,
  handleClose,
  dataOrder,
  setPedidoSelecionado,
  setRefreshPage,
}) {
  const classes = useStyles();
  const snackbar = useSnackbar();
  const [registrando, setRegistrando] = React.useState(false);
  const [cpfRetirante, setCpfRetirante] = React.useState("");
  const [nomeRetirante, setNomeRetirante] = React.useState("");
  const [nomeAtendente, setNomeAtendente] = React.useState("");
  const [observacao, setObservacao] = React.useState("");

  const setOrderAsCollectedInStore = useCallback(async () => {
    const obs = observacao.length > 0 ? observacao : "";

    setRegistrando(true);

    await Api.post(
      "set-order-as-collected-in-store",
      "order",
      {
        idPedido: dataOrder.IdPedido,
        cpfRetirante,
        nomeRetirante,
        nomeAtendente,
        observacoes: obs,
      },
      true
    )
      .then((value) => {
        if (value.Result) {
          snackbar.showMessage(
            `Registro de retirada do Pedido ${dataOrder.IdPedido} realizado com sucesso!`,
            {
              severity: "success",
            }
          );

          setCpfRetirante("");
          setNomeRetirante("");
          setNomeAtendente("");
          setObservacao("");

          setPedidoSelecionado(null);
          setRefreshPage(true);

          handleClose();
        }
      })
      .catch((error) => {
        snackbar.showMessage(
          "Ocorreu um erro ao registrar a retirada. Verifique os parâmetros informados.",
          {
            severity: "error",
          }
        );
        console.log(error);
      })
      .finally(() => setRegistrando(false));
  }, [
    cpfRetirante,
    dataOrder,
    handleClose,
    nomeAtendente,
    nomeRetirante,
    observacao,
    snackbar,
  ]);

  const registrar = useCallback(
    async (event) => {
      event.preventDefault();

      await setOrderAsCollectedInStore();
    },
    [setOrderAsCollectedInStore]
  );

  const validaCampos = useCallback(() => {
    return (
      cpfRetirante !== null &&
      cpfRetirante.length === 14 &&
      nomeRetirante.length > 0 &&
      nomeAtendente.length > 0
    );
  }, [cpfRetirante, nomeRetirante, nomeAtendente]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <span>
          <Typography variant="h3" component="h3">
            Registrar retirada do pedido {dataOrder.IdPedido}
          </Typography>
        </span>
      </DialogTitle>
      <DialogContent>
        <Typography id="alert-dialog-description" variant="h4">
          Preencha os campos para registrar retirada
        </Typography>
        <br />
        <InputText
          label="CPF do Retirante"
          value={cpfRetirante}
          onChange={(e) => {
            setCpfRetirante(
              e.target.value
                ?.replace(/\D/g, "")
                ?.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
                .slice(0, 14)
            );
          }}
          disabled={registrando}
          placeholder="000.000.000-00"
        />
        <InputText
          label="Nome do Retirante"
          value={nomeRetirante}
          onChange={(e) => {
            setNomeRetirante(e.target.value.slice(0, 200));
          }}
          disabled={registrando}
          placeholder="Digite o nome do retirante"
        />
        <InputText
          label="Nome do Atendente"
          value={nomeAtendente}
          onChange={(e) => {
            setNomeAtendente(e.target.value.slice(0, 200));
          }}
          disabled={registrando}
          placeholder="Digite o nome do atendente"
        />
        <InputText
          label="Observação"
          value={observacao}
          onChange={(e) => {
            setObservacao(e.target.value.slice(0, 4000));
          }}
          disabled={registrando}
          placeholder="Digite uma observação (opcional)"
        />
      </DialogContent>
      <DialogContent hidden={!registrando}>
        <div className={classes.root}>
          <span>Registrando retirada...</span>
          <LinearProgress />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="default" disabled={registrando}>
          Cancelar
        </Button>
        <Button
          component={Box}
          onClick={(e) => {
            registrar(e);
          }}
          color="default"
          variant="contained"
          disabled={!validaCampos() || registrando}
        >
          Registrar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
